import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { isNullOrUndefined } from '../../extensions';

@Component({
  selector: 'ig-field',
  templateUrl: './field.component.html',
  styleUrls: ['./field.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FieldComponent),
      multi: true
    }
  ],
  host: {
    '[class]': `class`
  }
})
export class FieldComponent implements ControlValueAccessor, OnInit {
  private _value: string;
  private _notifyChange: any;

  public isFocused: boolean;
  public errorText: string;
  @Input() public mode: 'input' | 'textarea' = 'input';
  @Input() public maxlength = '4000';
  @Input() public type = 'text';
  @Input() public class = 'text';
  @Input() public placeholder = '';
  @Input() public label: string;
  @Input() public label2: string;
  @Input() public icon: string;
  @Input() public maxLength: number;
  @Input() public minValue: number;
  @Input() public maxValue: number;
  @Input() public disabled: boolean;
  @Input() public readonly: boolean;
  @Input() public isRequired = false;
  @Input() public isSelectedOnInitial = false;
  @Input() public formControl: FormControl;
  @Input() public customErrorTexts: any;
  @Input() public isInnerLabel: boolean;
  @Input() public isSearch: boolean;
  @Input() public searching: boolean;
  @ViewChild('input') public input: ElementRef;
  @ViewChild('wrap') public wrap: ElementRef;
  @Output() onIconClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() onClear: EventEmitter<any> = new EventEmitter<any>();
  @Output() onFocus: EventEmitter<any> = new EventEmitter<any>();
  @Output() onKeyPressUp: EventEmitter<any> = new EventEmitter<any>();
  @Output() onEnterKeyUp: EventEmitter<any> = new EventEmitter<any>();

  public ngOnInit() {
    if (this.isSelectedOnInitial) {
      this.input.nativeElement.select();
    }
  }

  public get value() {
    return this._value;
  }

  public set value(newValue: any) {
    if (newValue === this._value || (isNullOrUndefined(this._value) && isNullOrUndefined(newValue))) {
      return;
    }

    this._value = newValue;

    if (this._notifyChange && this.formControl && this.formControl.value !== newValue) {
      this._notifyChange(newValue);
    }

    this.updateErrorText();
  }

  public writeValue(newValue: any): void {
    this._value = newValue;
  }

  public registerOnChange(fn: any): void {
    this._notifyChange = fn;
  }

  public registerOnTouched(fn: any): void {
  }

  public focus() {
    this.isFocused = true;
    this.wrap.nativeElement.style.backgroundColor = 'rgb(187, 225, 246)';
    this.onFocus.emit();
  }

  public onBlur() {
    this.isFocused = false;
    this.updateErrorText();
    this.wrap.nativeElement.style.backgroundColor = 'transparent';
  }

  public iconClick() {
    this.onIconClick.emit();
  }

  public clear() {
    this.value = '';
    this.onClear.emit();
  }

  public onKeyup(key) {
    if (key && key.key === 'Enter') {
      this.onEnterKeyUp.emit(key);
    } else {
      this.onKeyPressUp.emit(key);
    }
  }

  public updateErrorText() {
    this.errorText = '';

    if (this.formControl && this.formControl.dirty && this.formControl.errors) {
      for (let key of Object.keys(this.formControl.errors)) {
        if (!!this.customErrorTexts) {
          let customErrorText = this.customErrorTexts[key];

          if (customErrorText) {
            this.errorText = customErrorText;
            return;
          }
        }

        switch (key) {
          case 'required':
            return this.errorText = 'This field is required';

          case 'incorrectEmailFormat':
            return this.errorText = 'Incorrect email format';
        }
      }
    }
  }
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/field/field.component.ts